import React, { memo } from "react";
import AerosNode from "./AerosNode";

const link = process.env.REACT_APP_BACKEND_URL;

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="video" selected={selected} isConnectable={isConnectable}>
    <video controls className="nodrag" style={{ width: "100%", borderRadius: 8, display: "block" }}>
      <source src={`${link}/public/${data.url}`} type="video/mp4" />
    </video>
  </AerosNode>
));
